module.exports = __webpack_public_path__ + "images/collab_flow_bundle_tile.0010c576a77066dd352c41e764f3c3ab.png";